import { useSelector } from "react-redux";
import { oidcSelector } from "../../selectors/oidcSelectors";
import { useMemo } from "react";

export const ROLES = {
  CLIENT: "client",
  AUDITOR: "auditor",
  COORDINATOR: "coordinator",
  MANAGER: "manager",
  SYSTEM: "system",
  IT_ADMIN: "itadmin",
  MASTER: "master",
  CUSTOMER_SUPPORT: "customersupport",
};

const useRoles = () => {
  const oidc = useSelector(oidcSelector);
  const filterRolesFoo = (role) => (x) => x === role;

  const isClient = useMemo(() => {
    if (!oidc.user) return false;
    return !!oidc.user.profile.role.find(filterRolesFoo(ROLES.CLIENT));
  }, [oidc]);

  const isCoordinator = useMemo(() => {
    if (!oidc.user) return false;
    return !!oidc.user.profile.role.find(filterRolesFoo(ROLES.COORDINATOR));
  }, [oidc]);

  const isManager = useMemo(() => {
    if (!oidc.user) return false;
    return !!oidc.user.profile.role.find(filterRolesFoo(ROLES.MANAGER));
  }, [oidc]);

  const isMaster = useMemo(() => {
    if (!oidc.user) return false;
    return !!oidc.user.profile.role.find(filterRolesFoo(ROLES.MASTER));
  }, [oidc]);

  const isAuditor = useMemo(() => {
    if (!oidc.user) return false;
    return !!oidc.user.profile.role.find(filterRolesFoo(ROLES.AUDITOR));
  }, [oidc]);

  const isCustomerSupport = useMemo(() => {
    if (!oidc.user) return false;
    return !!oidc.user.profile.role.find(
      filterRolesFoo(ROLES.CUSTOMER_SUPPORT)
    );
  }, [oidc]);

  return {
    isClient,
    isCustomerSupport,
    isCoordinator,
    isManager,
    isMaster,
    isAuditor,
  };
};

export default useRoles;



// WEBPACK FOOTER //
// ./src/components/hooks/useRoles.jsx